<template>
    <div>
        <a-tabs>
            <template v-for="(i,index) in openingHours">
                <a-tab-pane :key="index" :tab="getWeekday(i.label)" :disabled="currentLabel!=-1">
                    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: 0, paddingBottom: '20px' }">
                        <a-form-model >

                            <!-- From time, to time -->
                            <a-row type="flex" :gutter="24">
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="From time"
                                    >
                                        <a-time-picker format="HH:mm" 
                                                    v-model="i.fromTime"
                                                    :disabled="!isEditable"
                                        />
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="To time"
                                    >
                                        <a-time-picker format="HH:mm" 
                                                        v-model="i.toTime"
                                                        :disabled="!isEditable"
                                        />   
                                    </a-form-model-item>
                                </a-col>

                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Can order from"
                                    >
                                        <a-time-picker format="HH:mm" 
                                                        v-model="i.canOrderFrom"
                                                        :disabled="!isEditable"
                                        />  
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Cannot order from"
                                    >
                                        <a-time-picker format="HH:mm" 
                                                        v-model="i.cannotOrderFrom"
                                                        :disabled="!isEditable"
                                        />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!-- / From time, to time -->

                            <!-- Can order from, cannot order from, off time -->
                            <a-row type="flex" :gutter="24">
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Off time"
                                    >
                                        <a-time-picker format="HH:mm" 
                                                        v-model="i.offTime" 
                                                        :disabled="!isEditable"/>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!-- / Can order from, cannot order from, off time -->

                            <!-- Waiting time -->
                            <a-row type="flex" :gutter="24">
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Min waiting time"
                                    >
                                        <a-slider :min="5" :max="60" :step="1" 
                                                    v-model="i.minWaitingTime"
                                                    :disabled="!isEditable"
                                        />
                                    </a-form-model-item>
                                </a-col>

                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Max waiting time"
                                    >
                                        <a-slider :min="1" :max="20" :step="1" 
                                                    v-model="i.maxWaitingTime"
                                                    :disabled="!isEditable"
                                        />
                                    </a-form-model-item>
                                </a-col>

                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Increase Time Step"
                                    >
                                        <a-slider :min="1" :max="20" :step="1" 
                                                    v-model="i.increaseTimeStep"
                                                    :disabled="!isEditable"
                                        />
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!-- / Waiting time -->

                            <!-- Waiting time -->
                            <a-row type="flex" :gutter="24">
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Init time of order"
                                    >
                                         <a-slider v-model="i.initTimeOfOrder" :min="1" :max="20" :step="1" :disabled="!isEditable"/>
                                    </a-form-model-item>
                                </a-col>

                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Pending order increase step"
                                    >
                                         <a-slider v-model="i.pendingOrderIncreaseStep" :min="1" :max="20" :step="1" :disabled="!isEditable"/>
                                    </a-form-model-item>
                                </a-col>

                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Capacity"
                                    >
                                         <a-slider v-model="i.capacity" :min="1" :max="20" :step="1" :disabled="!isEditable"/>
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!-- / Waiting time -->

                            <!-- Is Opened -->
                            <a-row type="flex" :gutter="24">
                                <a-col :span="24" :lg="6" class="mb-24">
                                    <a-form-model-item class="mb-10"
                                        label="Is Opened"
                                    >
                                        <a-switch v-model="i.isOpened" :disabled="!isEditable"/>     
                                    </a-form-model-item>
                                </a-col>
                            </a-row>
                            <!-- / Is Opened -->
                            
                        </a-form-model>
                        <a-row>
                            <a-col class="ml-auto" style="display: flex; align-items: center; justify-content: flex-end">
                                <a-button type="primary" class="ml-10" @click="handleBtnSave(i.label)" v-show="isEditable">SAVE</a-button>
                                <a-button type="bg-secondary" class="ml-10" @click="handleBtnEdit(i.label)" v-show="!isEditable">EDIT</a-button>
                                <a-button type="danger" class="ml-10" @click="handleBtnCancel(i.label)" v-show="isEditable">CANCEL</a-button>
                            </a-col>
					    </a-row> 
                    </a-card>
                </a-tab-pane>
            </template>
        </a-tabs>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
export default {
    computed : {
        ...mapState({
            openingHoursFromState: state => state.openingHours.openingHours
        })
    },
    data () {
        return {
            isEditable : false,
            openingHours : [],
            currentLabel : -1
        }
    },
    methods : {
        moment,
        getWeekday(label) {
            if (label === 0) {
                return 'SUN'
            }
            else if (label === 1) {
                return 'MON'
            }
            else if (label === 2) {
                return 'TUE'
            }
            else if (label === 3) {
                return 'WED'
            }
            else if (label === 4) {
                return 'THU'
            }
            else if (label === 5) {
                return 'FRI'
            }
            else {
                return 'SAT'
            }
        },
        async handleBtnSave(label) {

            this.isEditable = false;
            this.currentLabel = -1;

            let index = this.openingHours.findIndex(i => i.label == label );

            if (index > -1) {
                await this.$store.dispatch('openingHours/updateOpeningHourTableAction', {'label' : label, 'data' : this.openingHours[index] });
            }
        
        },
        handleBtnEdit(label) {
            this.isEditable = true;
            this.currentLabel = label;
        },

        handleBtnCancel(label) {
            this.isEditable = false;
            this.currentLabel = -1;
            //
            //restore
            //
            let o = this.$lodash.cloneDeep(this.$store.getters['openingHours/openingHourByLabel'](label));
            let index = this.openingHours.findIndex(i => i.label === label );
            if (index > -1) {
                this.openingHours[index] = o;
            }
        },

        handleChange(value) {
            console.log(value)
        }
    },
    async created () {

        await this.$store.dispatch('openingHours/getOpeningHoursTableAction', { });

        //this.menu = this.$lodash.cloneDeep(this.$store.getters['menus/menuById'](menuId));
       
        this.openingHours = this.$lodash.cloneDeep(this.$store.state.openingHours.openingHours);

        //console.log(this.openingHours)

    }

    
}
</script>

<style>

</style>